import { queryClient } from '@shared/libs/react-query';
import { useMutation } from '@tanstack/react-query';
import { inviteToOrganization } from 'services/ClaimscoreApiService/Invitations/Invitations.service';
import type {
  InviteToOrganizationPayload,
  InviteToOrganizationResponse,
} from 'services/ClaimscoreApiService/Invitations/types';

export const useInviteToOrganization = () =>
  useMutation<InviteToOrganizationResponse, Error, InviteToOrganizationPayload>(
    {
      mutationFn: (payload: InviteToOrganizationPayload) =>
        inviteToOrganization(payload),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['getAllInvitations'] });
      },
    },
  );
